<template>
  <div>
    <v-toolbar color="transparent elevation-0">
      <v-spacer></v-spacer>
      <v-text class="headline">{{item.name | capitalize}} Reviews</v-text>
      <v-spacer></v-spacer>
    </v-toolbar><span class="columns">
      <div class="column is-2">
        <span><v-img :src="item.productImages[0]" /></span>
        <router-link :to="'/product/'+ item.slug">
          <div class="ml-4 subtitle-1">
            <b>{{item.name| uppercase}}</b>
          </div>
        </router-link>
        <div class="ml-4 subtitle-2">
          <b>{{item.Cat_slug| capitalize}}</b>
        </div>
        <div class="ml-4 subtitle-2">
          <b>{{item.SubCat_slug| capitalize}}</b>
        </div>
        <br><br>
        <span class="ml-3 title-">
          <b>
            {{ commento.length }} 
            Review<span v-if="commento.length > 1">s</span> 
            <v-icon>mdi-comment-text-multiple-outline </v-icon>
          </b>
        </span>
      </div>
      <div class="column is-8">
        <v-timeline :reverse="reverse" dense>
          <v-slide-x-transition group>
            <v-timeline-item
              v-for="comment in commento"
              :key="comment.id"
            >
              <template v-slot:icon>
                <v-avatar v-if="comment.user_image">
                  <img :src="comment.user_image">
                </v-avatar>
                <v-avatar v-else>
                  <!-- <img src="http://i.pravatar.cc/64"> -->
                  <b style="color: white">
                    {{comment.user_name[0] | uppercase}}
                  </b>
                </v-avatar>
              </template>
              <v-card class="elevation-2">
                <v-card-text><v-card-title class="subtitle-1 font-weight-black">{{comment.user_name}}</v-card-title>{{comment.product_comment}}</v-card-text>
                <p style="text-align: right;" class="overline">
                  <b>
                    <v-icon
                      v-if="comment.user == uid"
                      small
                      color="purple lighten-2"
                      @click="deleteReview(comment)"
                    >
                      mdi-delete
                    </v-icon>
                    <timeago 
                      :datetime="comment.time"
                      :refresh="360"></timeago>
                  </b>
                </p>
              </v-card>
            </v-timeline-item>
          </v-slide-x-transition>
        </v-timeline>
      </div>
      <div class="column is-2">
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="indigo" fab small dark  v-on="on" @click="addNew"><v-icon>mdi-send mdi-24px</v-icon></v-btn>
          </template>
          <v-card style="border-radius: 15px;">
            <v-container>
              <v-system-bar style="background-color: white;">
                <v-spacer></v-spacer>
                <v-subheader><a><b @click="close">X</b></a></v-subheader>
              </v-system-bar>
              <b class="label">Review This Product Here.</b>
              <v-textarea append-outer-icon="mdi-message-reply-text" label="Your Review" outlined v-model="comments.product_comment" counter="100" auto-grow class="mx-2"></v-textarea>
              <a @click="switcher">
                <v-btn fab dark small color="green darken-1" class="mr-4" @click="addProductComments">
                  <v-icon>mdi-send mdi-24px</v-icon>
                </v-btn>
              </a>
            </v-container>
          </v-card>
        </v-dialog>
      </div>
    </span>
  </div>
</template>

<script>
  import {fb,db} from '@/firebase'

  export default {
    data: () => ({
      commento: [],
      reverse: true,
      item: null,
      dialog: false,
      product_comments: [],
      comments: {
        product_id: '',
        product_slug: '',
        product_comment: '',
        user_id: '',
        client_id: '',
        user_name: '',
        user_image: [],
        time: ''
      },
    }),
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    firestore: {
      product_comments: db.collection('product_comments')
    },
    methods: {
      addNew(){
        this.reset()
        this.dialog = true
      },
      deleteReview(comment){
        /* eslint-disable */
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            this.$firestoreRefs.product_comments.doc(comment.id).delete()
            .then(() => {
              this.switcher()              
            })                        
          }
        })
        /* eslint-enable */
      },
      switcher(){
        this.$router.push({ 
          name: 'reviews_alt', 
          params: { slug: this.item.slug }
        })
      },
      reset(){
        this.comments = {
          product_id: '',
          product_slug: '',
          product_comment: '',
          client_slug: '',
          user_name: '',
          user_id: ''
        }  
      },
      addProductComments(){
        db.collection('product_comments').add({
            product_id: this.item.id,
            product_slug: this.item.slug,
            client_slug: this.item.client,
            user_name: this.user.name,
            product_comment: this.comments.product_comment,
            user: fb.auth().currentUser.uid,
            user_image: this.user.user_image,
            time: Date()
        }).then(() => {
        /* eslint-disable */
          Toast.fire({
            type: 'success',
            title: 'Review Successful!'
          })
          this.close()
        }).catch(err => {
          console.log(err);
        })
        /* eslint-enable */
      },
      close () {
        this.dialog = false
      }
    },
    created(){
      this.uid = fb.auth().currentUser.uid

      db.collection('user')
      .where('user_id','==',fb.auth().currentUser.uid).get()
      .then(snapshot=>{
        snapshot.forEach(doc => {
          this.user =doc.data(),
          this.user.id = doc.id//
        })
      })

      let ref = db.collection('products')
      .where('slug', '==', this.$route.params.slug)
      ref.get().then(snapshot => {
        snapshot.forEach(doc => {
            this.item = doc.data()
            this.item.id = doc.id
        })
      })
      db.collection('product_comments')
      .where('product_slug','==',this.$route.params.slug)
      .get()
      .then(snapshot =>{
        snapshot.forEach(doc =>{
          let comment = doc.data()
          comment.id =  doc.id
          this.commento.push(comment) 
        })
      })
    }
  }
</script>